/**
 * Implement Gatsby's SSR (Server Side Rendering) APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/ssr-apis/
 */

// You can delete this file if you're not using it

import type { GatsbySSR } from 'gatsby'
import { I18nextProvider } from 'react-i18next'
import i18n from './src/internationalization/i18n'

export const wrapPageElement: GatsbySSR['wrapPageElement'] = ({ element }) => (
  <I18nextProvider i18n={i18n}>{element}</I18nextProvider>
)
